module.exports = __webpack_public_path__ + "img/upload.4ced3dab.svg";